import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import type { PlatformAdminData } from '../../../../+state/platform-identity/platform-identity.models';
import { selectCurrentAdmin } from '../../../../+state/platform-identity/platform-identity.selectors';
import type { RootState } from '../../../../common/interfaces/root-state.interface';

@Component({
  selector: 'cdw-dashboard',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="p-10">
      <div class="heading-lg mb-2">Platform Admin Console</div>
      <div class="body-text" *ngIf="admin$ | async as admin">
        Signed in as <strong>{{ admin.name || admin.email }}</strong>
        ({{ admin.profile.email }})
      </div>
      <div class="content-box mt-8">
        <div class="section-title">Welcome</div>
        <div class="section-content">
          Internal tooling for CDW AmplifiedIT will appear here. Customer
          onboarding is the first tool slated to land in this console.
        </div>
      </div>
    </div>
  `,
})
export class DashboardComponent {
  private store = inject<Store<RootState>>(Store);
  admin$: Observable<PlatformAdminData | null> =
    this.store.select(selectCurrentAdmin);
}
